// hooks/useRemoveRolePermissions.js
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { removeRolePermissions } from '../api/ROLES/roles';
import { toast } from 'react-toastify';

export const useRemoveRolePermissions = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ roleId, permissionIds }) => removeRolePermissions(roleId, permissionIds),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['roles'] });
            toast.success('Permission retirée avec succès');
        },
        onError: (error) => {
            toast.error(error.message || 'Erreur lors de la suppression de la permission');
        },
    });
};